module.exports = __webpack_public_path__ + "static/media/map-guerin-shadow.bb6215e1.svg";